import React, { useState, useEffect } from "react";
import ThemeMaker from "../../components/thememaker";
import { useHistory } from "react-router-dom";
import { Table, Tag } from "antd";
import axios from "axios";
import { IoIosEye } from "react-icons/io";
import { Modal as AntModal } from "antd";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { config } from "../../utils/config";
import { Button, ConfigProvider, Flex, Tooltip } from 'antd';
import { IoIosInformationCircleOutline } from "react-icons/io";

export default function FindProduct() {
    const baseUrl = config.apiUrl;
    const history = useHistory();
    const [data, setData] = useState([]);
    const [open, setopen] = useState(false);
    const [biddingData, setBiddingData] = useState([]);
    const [sendata, setsenddata] = useState();
    const [bidModal, setBidModal] = useState(false);
    const [bidAmount, setBidAmount] = useState([])
    const [selectedSession, setSelectedSession] = useState(null);
    console.log("selectedSession--->", selectedSession)
    console.log("bidAmount--->", bidAmount)
    console.log("345678909876543", sendata)

    const columns = [
        {
            title: "Transaction ID",
            dataIndex: "transaction_id",
        },
        {
            title: "Time To Live",
            render: (_, record) => record?.ttl
        },
        {
            title: "Buyer ID",
            render: (_, record) => record?.bpp_id
        },
        {
            title: "Product Name",
            render: (_, record) =>
                record?.items?.map((item, index) => {
                    const details = item?.product_details;

                    return (
                        <div
                            key={index}
                            className="d-flex align-items-center"
                            style={{ gap: "5px", width: "300px" }}
                        >
                            <p className="m-0 p-0">{`${index + 1}. `}</p>

                            <p className="m-0 p-0">
                                {item?.product_name}  {"(\u20B9" + item?.price + ")"}

                            </p>
                        </div>
                    );
                }) || "-"
        },
        {
            title: "Warehouse Name",
            render: (_, record) => record?.warehouse?.warehouse_name
        },


        // {
        //     title: "Price Details",
        //     render: (_, record) => <><p className="m-0 p-0" style={{ width: "200px" }}>
        //         <span> base price : {record?.product_details?.base_price}</span> <br />
        //         <span>current price : {record?.product_details?.current_price}</span>   <br />
        //         <span> minimum price : {record?.product_details?.minimum_price}</span>  <br />
        //         <span> maximum price : {record?.product_details?.maximum_price}</span>  <br />
        //     </p>
        //     </>
        //         || "-"

        //     render: (_, record) => record?.items?.map((item, index) => {
        //         let text = <><p className="m-0 p-0" style={{ width: "200px" }}>
        //             <span> base price : Rs {item?.product_details?.base_price}</span> <br />
        //             <span>current price : Rs {item?.product_details?.current_price}</span>   <br />
        //             <span> minimum price : Rs {item?.product_details?.minimum_price}</span>  <br />
        //             <span> maximum price : Rs {item?.product_details?.maximum_price}</span>  <br />
        //         </p> </>

        //         return <><div className="d-flex align-items-center" style={{ gap: "5px", width: "200px" }}> <p className="m-0 p-0">{`${index + 1}. `}</p>
        //             <p className="m-0 p-0" > {item?.price}</p>

        //         </div>
        //         </>
        //     }) || "-"
        // },
        {
            title: "Area Code",
            render: (_, record) => record?.warehouse?.area_code

        },

        {
            title: "Type",
            render: (_, record) => {
                return record?.type ? (
                    <p className="m-0 p-0">{record.type}</p>
                ) : "-";
            }
        },
        // {
        //     title: "Action",
        //     render: (_, record) => (
        //         <div style={{ display: "flex", gap: "5px" }}>

        //             {!record?.action == 'ACCEPTED' ? (
        //                 <>
        //                     <button
        //                         style={{ cursor: "pointer", backgroundColor: "green", color: "white", border: "none", padding: "4px 8px", borderRadius: "4px" }}
        //                         onClick={() => handlesendapi("ACCEPT", record)}
        //                     >
        //                         Accept
        //                     </button>

        //                     <button
        //                         style={{ cursor: "pointer", backgroundColor: "red", color: "white", border: "none", padding: "4px 8px", borderRadius: "4px" }}
        //                         onClick={() => handlesendapi("REJECT", record)}
        //                     >
        //                         Reject
        //                     </button>
        //                 </>
        //             ) : (

        //                 <span style={{ fontWeight: "bold", color: record?.action === "ACCEPTED" ? "green" : "red" }}>
        //                     {record?.action}

        //                 </span>
        //             )}

        //         </div>
        //     )
        // }
        {
            title: "Action",
            render: (_, record) => (
                <div style={{ display: "flex", gap: "5px" }}>

                    {!record?.action ? (
                        <>
                            <button
                                style={{
                                    cursor: "pointer",
                                    backgroundColor: "green",
                                    color: "white",
                                    border: "none",
                                    padding: "4px 8px",
                                    borderRadius: "4px"
                                }}
                                onClick={() => handlesendapi("ACCEPT", record)}
                            >
                                Accept
                            </button>

                            <button
                                style={{
                                    cursor: "pointer",
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                    padding: "4px 8px",
                                    borderRadius: "4px"
                                }}
                                onClick={() => handlesendapi("REJECT", record)}
                            >
                                Reject
                            </button>
                        </>
                    ) : (
                        <span
                            style={{
                                fontWeight: "bold",
                                color: record?.action === "ACCEPTED" ? "green" : "red"
                            }}
                        >
                            {record?.action}
                        </span>
                    )}

                </div>
            )
        }
    ];



    const handlesendapi = async (actionType, record) => {
        const payload = {
            transaction_id: record?.transaction_id,
            action: actionType,
            items: bidAmount
        };

        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/invl/dashboard/init_action_ilfp`,
                method: "POST",
                data: payload
            });

            if (actionType === "REJECT") {
                toast.error("Item Rejected!", { position: "top-right", toastId: "reject-toast" });
            } else if (actionType === "ACCEPT") {
                toast.success("Item Accepted!", { position: "top-right", toastId: "accept-toast" });
            }

            await getAllwarehouse();

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong!", { toastId: "error-toast" });
        }
    };


    const biddingColumns = [
        {
            title: "Round Number",
            dataIndex: "round_number",
        },
        {
            title: "Item Name",
            dataIndex: "item_name",
        },

        {
            title: "Item ID",
            dataIndex: "item_id",
        },


        {
            title: "Lowest Bid",
            dataIndex: "lowest_bid",
            render: (val) => val ?? "-"
        },
        {
            title: "Seller Bid",
            dataIndex: "seller_bid",
            render: (val) => val ?? "-"
        },
        {
            title: "Action Taken",
            dataIndex: "action_taken",
            render: (val) => (val ? "Yes" : "No")
        },
        {
            title: "Seller Action",
            dataIndex: "seller_action",
            render: (val) => val ?? "-"
        },
        {
            title: "Action At",
            dataIndex: "action_at",
            render: (val) => val ? new Date(val).toLocaleString() : "-"
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            render: (val) => new Date(val).toLocaleString()
        },

    ];

    const getAllwarehouse = async () => {
        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/invl/dashboard/get_ilfp`,
                method: "POST",
            });

            setData(response?.data?.data || []);
            const passdata = response?.data?.data
            console.log("wertyuiop--->", response?.data?.data)
            setsenddata(response?.data?.data || []);
        } catch (error) {
            console.log("Error -------->", error);
        }
    };

    useEffect(() => {
        getAllwarehouse();
    }, []);



    // const filteredBiddingData = biddingData.filter(item => item.round_number > 0);



    return (
        <ThemeMaker>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className=" m-0 mt-1">
                <div className="p-2">
                    <div className="" style={{ width: "100%", height: "80vh", overflowY: "scroll" }}>

                        <Table
                            columns={columns}
                            dataSource={data}
                            rowKey="id"
                            style={{ width: "100%" }}
                        />

                    </div>
                </div>
            </div>

            <AntModal className="mt-5"
                title="Bidding Details"
                open={open}
                onCancel={() => setopen(false)}
                footer={null}
                centered
                width={1200}
            >


                <Table
                    columns={biddingColumns}
                    dataSource={biddingData}
                    rowKey="id"
                    pagination={false}
                    style={{ maxHeight: "350px", overflow: "scroll" }}

                />

                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                    <button

                        style={{
                            background: "green",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",

                            borderRadius: "4px"
                        }}
                        onClick={() => setBidModal(true)}
                    >
                        Accept
                    </button>
                    <button

                        style={{
                            background: "red",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",

                            borderRadius: "4px"
                        }}
                        onClick={() => handlesendapi("REJECT")}
                    >
                        Reject
                    </button>
                </div>
            </AntModal>

            <AntModal
                title="Enter Bid Amount"
                open={bidModal}
                onCancel={() => setBidModal(false)}
                centered
                footer={null}
            >
                {
                    selectedSession?.data?.map(item => {
                        return <>

                            <input
                                type="number"
                                placeholder={`bid amount ${item?.product_details?.name}`}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    const item_id = item?.item_id;

                                    setBidAmount((prev) => {
                                        const existing = prev.find(i => i.item_id === item_id);

                                        if (existing) {
                                            return prev.map(i =>
                                                i.item_id === item_id ? { ...i, seller_bid: value } : i
                                            );
                                        } else {
                                            return [...prev, { item_id: item_id, seller_bid: value }];
                                        }
                                    });
                                }}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    marginTop: "10px"
                                }}
                            />
                        </>
                    })
                }

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <button
                        style={{
                            padding: "5px 10px",
                            color: "white",
                            background: "blue",
                            borderRadius: "10px",
                            border: "none",
                            margin: "10px"
                        }}

                        onClick={() => handlesendapi("ACCEPT")}
                    >Submit</button>
                </div>
            </AntModal>

        </ThemeMaker>
    );
}
